"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localiseHostName = exports.isPrcHostname = exports.isLocalPrcHostname = exports.getPlatformAndWorkspaceSlug = exports.getCurrentHostname = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _constants = require("../constants");
var _environmentUtils = require("./environment-utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var defaultHostPattern = /^(.*swipe(guide\.com|\.local)|localhost)$/g;
var prcHostPattern = /^(.*swipeguide\.cn|cn\.default\.swipe\.local)$/g;
var defaultRewriteRules = [{
  from: _constants.CLOUDINARY_CDN_HOSTNAME,
  to: _constants.CLOUDINARY_CDN_HOSTNAME
}, {
  from: _constants.CLOUDINARY_API_HOSTNAME,
  to: _constants.CLOUDINARY_API_HOSTNAME
}];

// WARNING: Order is significant. First match is applied.
var hostNameLocalisationRules = [{
  pattern: prcHostPattern,
  rewriteRules: [{
    from: _constants.CLOUDINARY_CDN_HOSTNAME,
    to: 'res-cloudinary-com.swipeguide.cn'
  }, {
    from: _constants.CLOUDINARY_API_HOSTNAME,
    to: _constants.CLOUDINARY_API_PRC_PROXY_HOSTNAME
  }, {
    from: _constants.termsAndConditionsUrl,
    to: 'https://swipeguide.cn/terms-and-conditions'
  }]
}, {
  pattern: defaultHostPattern,
  rewriteRules: defaultRewriteRules
}];
var localiseHostName = exports.localiseHostName = function localiseHostName(url) {
  var currentHostname = (0, _get["default"])(window, 'location.hostname', '');
  var matchedRules = hostNameLocalisationRules.find(function (_ref) {
    var pattern = _ref.pattern;
    return currentHostname.match(pattern);
  });
  var _ref2 = matchedRules || {
      rewriteRules: defaultRewriteRules
    },
    rewriteRules = _ref2.rewriteRules;
  var _ref3 = rewriteRules.find(function (_ref4) {
      var from = _ref4.from;
      return url.includes(from);
    }) || {},
    from = _ref3.from,
    to = _ref3.to;
  return url.replace(from, to);
};
var getCurrentHostname = exports.getCurrentHostname = function getCurrentHostname() {
  return ((window || {}).location || {}).hostname;
};
var isPrcHostname = exports.isPrcHostname = function isPrcHostname(hostname) {
  return typeof hostname === 'string' && hostname.match(prcHostPattern);
};
var isLocalPrcHostname = exports.isLocalPrcHostname = function isLocalPrcHostname(hostname) {
  return isPrcHostname(hostname) && !(0, _environmentUtils.isProductionEnvironment)(hostname);
};
var getPlatformAndWorkspaceSlug = exports.getPlatformAndWorkspaceSlug = function getPlatformAndWorkspaceSlug() {
  var hostname = getCurrentHostname() || '';
  if (isLocalPrcHostname(hostname)) {
    hostname = hostname.replace(/^cn\./, '');
  }
  var subdomain = hostname.split('.')[0];
  var parts = subdomain.split('-');
  var _parts$reverse = parts.reverse(),
    _parts$reverse2 = _slicedToArray(_parts$reverse, 2),
    platformSlug = _parts$reverse2[0],
    workspaceSlug = _parts$reverse2[1];
  return {
    platformSlug: platformSlug,
    workspaceSlug: workspaceSlug
  };
};
//# sourceMappingURL=host-utils.js.map